import calEventEditEngine from '../../../../../CalendarWidget/Core/CalEventEditEngine';
import commandEngine from './CommandEngine';

/**
 * Registers the /cal command with the CommandEngine.
 * Call once at module load from YourLibraryTab.
 *
 * /cal <label> <date> <time> <cat> <remind>
 */
export function registerCalEventCommand() {
    const today = new Date().toISOString().slice(0, 10);

    commandEngine.register('/cal', {
        hint: 'Create calendar event',
        params: [
            { name: 'label', hint: '<label>' },
            { name: 'date', hints: ['<YYYY-MM-DD>', today] },
            { name: 'time', hint: '<HH:MM>' },
            { name: 'remind', hint: '<30m|2h|1d>' },
            // { name: 'cat', hint: '<category>' },
        ],
        handler: (params) => {
            calEventEditEngine.startEdit('__new__');
            const [label, date, time, cat, remind] = params;
            const patch = {};
            if (label) patch.label = label;
            if (date) patch.date = date;
            if (time) patch.time = time;
            // if (cat) patch.cat = cat;
            if (remind) patch.remind = remind;
            if (Object.keys(patch).length) calEventEditEngine.patchDraft(patch);
        },
    });
}
